export default "__VITE_ASSET__7mhWBrLw__"